import {
    ApplicationConfig,
    importProvidersFrom,
    inject,
    provideAppInitializer,
    provideZoneChangeDetection
} from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter } from "@angular/router";
import { EventsService } from "@arch/domain/application/services/events.service";
import { CompanyContactEntity } from "@arch/domain/entity/company-contact.entity";
import { GetCompanyContactByIdController } from "@arch/presentation/controllers";
import Hotjar from "@hotjar/browser";
import { QuillModule } from "ngx-quill";
import { environment } from "../environments/environment";
import { providers } from "./app.providers";
import { routes } from "./app.routes";
import { ContactService } from "./shared/services/contact.service";
import { JwtAuthService } from "./shared/services/jwt-auth.service";

const beforeAppInit = async () => {
    const jwtAuth = inject(JwtAuthService);
    const eventsService = inject(EventsService);
    const contactService = inject(ContactService);
    const getCompanyContactByIdController = inject(
        GetCompanyContactByIdController
    );
    const urlParams = new URLSearchParams(window.location.search);
    const liveToken = urlParams.get("liveToken");
    if (liveToken) {
        await jwtAuth.checkLiveToken(liveToken);
    }
    const contactId = urlParams.get("contactId");
    const userId = urlParams.get("userId");
    let contact: CompanyContactEntity;
    const currentContact = contactService.get();
    if (currentContact && !contactId && !userId) {
        contact = currentContact;
    } else {
        contact = await getCompanyContactByIdController.execute({
            contactId,
            userId
        });
        contactService.set(contact);
    }
    try {
        eventsService.init(environment.MIXPANEL_TOKEN);
        eventsService.identify({
            _id: contact.props._id,
            email: contact.props.email,
            type: contact.props.type
        });
    } catch (error) {
        console.error("[Analytics] Mixpanel setup failed", error);
    }

    if (environment.production) {
        try {
            Hotjar.init(6477481, 6);
        } catch (error) {
            console.error("[Analytics] Hotjar init failed", error);
        }
    }
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimationsAsync(),
        importProvidersFrom(QuillModule.forRoot()),
        ...providers,
        provideAppInitializer(beforeAppInit)
    ]
};
